<script lang="ts">
	import ArticleCard from "@components/ArticleCard.svelte";
	import HugeHeading from "@components/HugeHeading.svelte";
	import Button from "@components/common/Button.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import type { BlogProps } from "./BlogProps.js";

	const { articles }: BlogProps = $props();
	let articlesToShowCount = $state(9);
</script>

<Layout ogImage={articles.find(({ primaryImage }) => primaryImage !== undefined)?.primaryImage}>
	<section
		class="flex full-width items-center pt-12 pb-16 sm:pb-24 xl:pb-[8.4375rem] gap-16 sm:gap-14 lg:gap-[5.375rem] flex-col px-4"
	>
		<HugeHeading
			level={1}
			class="text-center mild"
			text="stroke[[Pravidelná dodávka]] nl[[]] novinek ze světa mezi regály"
		/>
		<p
			class="text-[1.25rem]/[1.2] md:text-xl/[1.2] lg:text-[2rem]/[1.2] font-bold max-w-full sm:max-w-[50rem] lg:max-w-[75rem] text-center text-cmcsecondary px-4"
		>
			<Formatted
				text="Logistiku nejen děláme v praxi, ale také o ní píšeme a natáčíme. Pokud nechcete přijít o žádné důležité novinky z oboru, jste na správném místě."
			/>
		</p>
	</section>
	<section
		class="grid grid-cols-1 lg:grid-cols-2 gap-2 items-stretch full-width mx-4 md:mx-auto max-w-[107.5rem] py-8 sm:py-12 lg:py-20 px-4 sm:px-6 lg:px-8"
	>
		{#if articles.length > 0}
			{#each articles.slice(0, articlesToShowCount) as article (article.id)}
				<ArticleCard {article} class="w-full" />
			{/each}
		{:else}
			<p class="text-center col-span-full">
				<Formatted text="Zatím zde nejsou žádné články." />
			</p>
		{/if}
	</section>
	{#if articlesToShowCount < articles.length}
		<Button
			variant={ButtonVariant.Outlined}
			class="my-8 sm:my-12 lg:my-16 mx-auto"
			icon="arrow"
			onclick={(): void => {
				articlesToShowCount = Math.min(articlesToShowCount + 9, articles.length);
			}}
		>
			<Formatted text="Zobrazit další" />
		</Button>
	{/if}
</Layout>
